import * as flux from 'flux'

export const Base_Dispatcher = new flux.Dispatcher()
